import { render, staticRenderFns } from "./NamesComponent.vue?vue&type=template&id=659f7fcd&scoped=true"
import script from "./NamesComponent.vue?vue&type=script&lang=js"
export * from "./NamesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659f7fcd",
  null
  
)

export default component.exports